export class ItemScheduleConfiguration {
    constructor(data) {
        const dataExist = data !== null && data !== undefined;
        this.works_on_monday = dataExist ? data.works_on_monday : true;
        this.works_on_tuesday = dataExist ? data.works_on_tuesday : true;
        this.works_on_wednesday = dataExist ? data.works_on_wednesday : true;
        this.works_on_thursday= dataExist ? data.works_on_thursday : true;
        this.works_on_friday = dataExist ? data.works_on_friday : true;
        this.works_on_saturday = dataExist ? data.works_on_saturday : true;
        this.works_on_sunday = dataExist ? data.works_on_sunday : true;
    }

    setWorksOnMonday(value) {
        this.works_on_monday = value;
    }

    setWorksOnTuesday(value) {
        this.works_on_tuesday = value;
    }

    setWorksOnWednesday(value) {
        this.works_on_wednesday = value;
    }

    setWorksOnThursday(value) {
        this.works_on_thursday = value;
    }

    setWorksOnFriday(value) {
        this.works_on_friday = value;
    }

    setWorksOnSaturday(value) {
        this.works_on_saturday = value;
    }

    setWorksOnSunday(value) {
        this.works_on_sunday = value;
    }

    worksOnMonday(){
        return this.works_on_monday;
    }

    worksOnTuesday(){
        return this.works_on_tuesday;
    }

    worksOnWednesday(){
        return this.works_on_wednesday;
    }

    worksOnThursday(){
        return this.works_on_thursday;
    }

    worksOnFriday(){
        return this.works_on_friday;
    }

    worksOnSaturday(){
        return this.works_on_saturday;
    }

    worksOnSunday(){
        return this.works_on_sunday;
    }

    hasScheduleConfiguration() {
        return !this.worksOnMonday() || !this.worksOnTuesday() || !this.worksOnWednesday() || !this.worksOnThursday() || !this.worksOnFriday() || !this.worksOnSaturday() || !this.worksOnSunday();
    }

    data() {
        return {
            "works_on_monday": this.worksOnMonday(),
            "works_on_tuesday": this.worksOnTuesday(),
            "works_on_wednesday": this.worksOnWednesday(),
            "works_on_thursday": this.worksOnThursday(),
            "works_on_friday": this.worksOnFriday(),
            "works_on_saturday": this.worksOnSaturday(),
            "works_on_sunday": this.worksOnSunday()
        };
    }

    workOnDays() {
        const daysInitials = []
        if(this.worksOnMonday())
            daysInitials.push("Lu");

        if(this.worksOnTuesday())
            daysInitials.push("Ma");

        if(this.worksOnWednesday())
            daysInitials.push("Mi");

        if(this.worksOnThursday())
            daysInitials.push("Ju");

        if(this.worksOnFriday())
            daysInitials.push("Vi");

        if(this.worksOnSaturday())
            daysInitials.push("Sá");

        if(this.worksOnSunday())
            daysInitials.push("Do");

        return daysInitials;
    }

    isSame(otherItemScheduleConfiguration) {
        if (!otherItemScheduleConfiguration) {
            return false;
        }

        return this.worksOnMonday() === otherItemScheduleConfiguration.worksOnMonday() &&
            this.worksOnTuesday() === otherItemScheduleConfiguration.worksOnTuesday() &&
            this.worksOnWednesday() === otherItemScheduleConfiguration.worksOnWednesday() &&
            this.worksOnThursday() === otherItemScheduleConfiguration.worksOnThursday() &&
            this.worksOnFriday() === otherItemScheduleConfiguration.worksOnFriday() &&
            this.worksOnSaturday() === otherItemScheduleConfiguration.worksOnSaturday() &&
            this.worksOnSunday() === otherItemScheduleConfiguration.worksOnSunday();
    }

}

